// extracted by mini-css-extract-plugin
export default {"root":"LoginPanel-root--MP7zu","foot":"LoginPanel-foot--gZ8xo"};